const MockProducts = [
    {
        id: 1,
        nombre: "MF 930 Sellador de silicona neutra",
        categoria: "Construcción",
        descripcionProducto: "SILANDE® MF 930 es un sellador de silicona RTV de curado neutro, monocomponente, diseñado para la fijación interna de espejos, productos de vidrio, vidrio revestido, cerámica, paneles metálicos en diversos sustratos, así como para pegar vidrio, placas de montaje en paneles solares térmicos.",
        caracteristicasRendimiento: "Excelente adhesión a una amplia gama de sustratos, incluidos vidrio revestido, acero galvanizado, mampostería, aluminio anodizado y revestido de poliéster y acero inoxidable, otros sustratos porosos y no porosos. Ideal para juntas de dilatación, juntas, juntas perimetrales y otras juntas móviles. El sellador tiene alta resistencia al calor y la humedad. Resistencia a temperaturas de -60 °C a +180 °C. Alta resistencia a la tensión mecánica. Alta elasticidad y alta modularidad. Sellador resistente al ozono.",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 2,
        nombre: "MF910H Sellador de butilo 2da barrera",
        categoria: "Construcción",
        descripcionProducto: "SILANDE MF910H es un sellador termofusible plástico permanente, sin disolventes, antiempañante, diseñado específicamente para el sellado secundario de fabricantes de vidrio aislante que ejecutan operaciones de aplicación manual, semiautomáticas y de extrusión lineal.",
        caracteristicasRendimiento: "Excelente adhesión a una amplia gama de sustratos, incluidos vidrio, aleaciones de aluminio, acero galvanizado y acero inoxidable. Mantiene sus propiedades plásticas y de sellado en un amplio rango de temperaturas. Alta resistencia mecánica inmediata después de la aplicación para capacidades de manipulación y transporte. Excelente resistencia al asentamiento, lo que resulta en una reducción del uso de herramientas después de la aplicación. Baja adherencia después de la aplicación para una fácil manipulación. Tasa máxima de permeación de vapor de humedad y gas. Excelente estabilidad de temperatura: -30°C a 80°C",
        normasAplicables: "EN1279 - part 4",
        colores: "",
        packaging: "Caja de 6,5 kg (Φ185mm). Barril de 220 kg (Φ571,5mm)",
        vidaUtil: "24 meses desde la fecha de fabricación, almacenar en un lugar oscuro con baja humedad por debajo de 30°C en el envase original sin abrir"
    },
    {
        id: 3,
        nombre: "MF910G Sellador de butilo 1ra barrera",
        categoria: "Construcción",
        descripcionProducto: "SILANDE MF910 es un sellador permanente de butilo monocomponente, sin disolventes y antiempañante, diseñado específicamente para el sellado primario de unidades de vidrio aislante.",
        caracteristicasRendimiento: "Excelente adhesión a una amplia gama de sustratos, incluidos vidrio, aleaciones de aluminio, acero galvanizado y acero inoxidable. Mantiene sus propiedades plásticas y de sellado en un amplio rango de temperaturas. Tasa máxima de permeación de vapor de humedad y gas. Excelente estabilidad de temperatura: -30°C a 80°C",
        normasAplicables: "EN1279 - part 4. JC/T 914. IGCC-IGMA Approved.",
        colores: "",
        packaging: "Caja de 7 kg (Φ 190mm). Caja de 6 kg (Φ 190mm). Barril de 190 kg (Φ 571,5mm).",
        vidaUtil: "24 meses desde la fecha de fabricación, almacenar en un lugar fresco, seco y ventilado por debajo de 30°C"
    },
    {
        id: 4,
        nombre: "MF910 Sellador de butilo 1ra barrera",
        categoria: "Construcción",
        descripcionProducto: "SILANDE MF910 es un sellador permanente de butilo monocomponente, sin disolventes y antiempañante, diseñado específicamente para el sellado primario de unidades de vidrio aislante.",
        caracteristicasRendimiento: "Excelente adhesión a una amplia gama de sustratos, incluidos vidrio, aleaciones de aluminio, acero galvanizado y acero inoxidable. Mantiene sus propiedades plásticas y de sellado en un amplio rango de temperaturas. Tasa máxima de permeación de vapor de humedad y gas. Excelente estabilidad de temperatura: -30°C a 80°C",
        normasAplicables: "EN1279 - part 4. JC/T 914",
        colores: "",
        packaging: "Caja de 7 kg (Φ 185mm). Caja de 6 kg (Φ 185mm). Caja de 5 kg (Φ 160mm). Caja de 2 kg (Φ 126mm)",
        vidaUtil: "24 meses desde la fecha de fabricación, almacenar en un lugar fresco, seco y ventilado por debajo de 30℃"
    },
    {
        id: 5,
        nombre: "MF 899F Sellador estructural de silicona",
        categoria: "Construcción",
        descripcionProducto: "SILANDE® MF 899F es un sellador de silicona RTV estructural, monocomponente, de curado neutro y resistente al fuego, diseñado para el ensamblaje estructural de sistemas de fachadas de gran altura y súper alta altura, productos de vidrio de gran formato en fachadas y estructuras de fachadas estructurales complejas. Cumple con el estándar ETAG002. El sellador también se puede utilizar para la protección contra incendios de juntas en uniones de ventanas y puertas, fachadas de muro cortina hechas de varias capas: impermeabilización, acabado, protección contra la humedad en varios edificios públicos. El sellador es fácil de aplicar en cualquier clima y se endurece cuando entra en contacto con la humedad del aire, formando una junta de silicona elástica y confiable.",
        caracteristicasRendimiento: "Excelente protección contra incendios y resistencia al fuego. Cumple con la normativa ETAG002 con una garantía de 25 años. Excelente adhesión a una amplia gama de sustratos, incluidos vidrio revestido, vidrio esmaltado y reflectante, aluminio y acero inoxidable anodizado y revestido de poliéster, y otros sustratos porosos y no porosos. La alta resistencia a la tracción hace que el sellador sea adecuado para la unión estructural. Resistencia a temperaturas de -60 °C a +180 °C. Excelente resistencia a la intemperie, alta resistencia a los rayos UV, al calor y a la humedad. Buena adherencia a la mayoría de los materiales de construcción sin imprimación. Fácil de aplicar con una pistola pulverizadora estándar. El sellador no contiene disolventes y es seguro para el medio ambiente.",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 6,
        nombre: "MF 899T Sellador estructural de silicona",
        categoria: "Construcción",
        descripcionProducto: "SILANDE MF 899T es un sellador de silicona RTV de curado neutro, de un solo componente, desarrollado para la unión estructural de paneles de vidrio de gran tamaño en sistemas de muro cortina, unión puntual de muros cortina portantes, ventanas de techo y sellos para muros cortina de vidrio aislante con marcos ocultos. Se puede utilizar en radioelectrónica e ingeniería de iluminación.El sellador es fácil de aplicar en cualquier clima. La polimerización se produce cuando la humedad del aire actúa sobre el sellador, que después de la polimerización forma una unión de silicona duradera y elástica.",
        caracteristicasRendimiento: "Excelente adhesión a una amplia gama de sustratos, incluidos vidrio revestido, acero galvanizado, mampostería, aluminio anodizado y revestido de poliéster y acero inoxidable, otros sustratos porosos y no porosos. Su alta resistencia a la tracción permite que el producto sea utilizado en uniones estructurales. Excelente resistencia a las influencias atmosféricas, incluida la radiación UV, el calor y la humedad. Resistencia a temperaturas de -60 °C a +180 °C. Alta resistencia a la tensión mecánica. Alta elasticidad y alta modularidad. Sellador resistente al ozono.",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 7,
        nombre: "MF 899-25 Sellador estructural de silicona",
        categoria: "Construcción",
        descripcionProducto: "SILANDE® MF 899T posee resistencia única al clima, se mantiene sólido incluso si se expone a condiciones adversas. El rendimiento del diseño original de la costura no tiene cambios significativos debido al envejecimiento y la exposición a la atmósfera, y el adhesivo sellador mantiene las características de impermeabilidad, resistencia a la intemperie y resistencia estructural.El pegamento sellador solidificado permanece elástico en un rango de temperatura elevado de -60 °C y no se vuelve quebradizo, agrietado ni desgarrado.",
        caracteristicasRendimiento: "Curado neutro, sin corrosión de la superficie viscosa, adecuado para revestir vidrio, vidrio flotado, material de madera, perfil de aluminio, placa de acero galvanizado, ladrillo y otros materiales. Excelente rendimiento a altas y bajas temperaturas y rendimiento resistente a la intemperie, en su capacidad de desplazamiento, con deformación repetida intercambiable a altas y bajas temperaturas, extremadamente pequeña para el rendimiento del sellador en sí. Ideal para estirar, conectar, rodear sellos y otras uniones móviles.",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 8,
        nombre: "MF899 Sellador de silicona estructural",
        categoria: "Construcción",
        descripcionProducto: "SILANDE MF899 es un sellador estructural de silicona curada neutra, de un componente, diseñado específicamente para la unión estructural de vidrio, metal y otros componentes de construcción. También se puede utilizar para adherir elementos de refuerzo a paneles de construcción y otras aplicaciones adhesivas similares. Se extruye fácilmente en cualquier clima y cura a temperatura ambiente mediante la reacción con la humedad del aire, formando un sello de caucho de silicona flexible y duradero.",
        caracteristicasRendimiento: "Excelente adhesión a una amplia gama de sustratos, incluidos vidrio revestido, acero galvanizado, mampostería, aluminio y acero inoxidable anodizados y revestidos con pintura de poliéster, y otros sustratos porosos y no porosos. Su alta resistencia a la tracción máxima lo hace ideal para aplicaciones de unión estructural. Excelentes características de intemperie y alta resistencia a la radiación ultravioleta, al calor y a la humedad. Excelente estabilidad de temperatura: -5O°C a 180°C. Alto nivel de propiedades mecánicas. Excelente resistencia al envejecimiento climático.",
        normasAplicables: "ASTM C920 / C1184. ETAG 002. GB 16776. JC/T 475.",
        colores: "Negro/blanco/gris/transparente. Se pueden solicitar colores personalizados para que coincidan con prácticamente cualquier sustrato.",
        packaging: "Cartucho: 300ml (25 unidades). Tubo: 592ml (20 unidades)",
        vidaUtil: "12 meses desde la fecha de fabricación, almacenar en un lugar fresco, seco y ventilado por debajo de 30°C en el embalaje original sin abrir"
    },
    {
        id: 9,
        nombre: "MF 898 Sellador impermeabilizante de silicona",
        categoria: "Construcción",
        descripcionProducto: "SILANDE® MF 898 es un sellador de silicona RTV de curado neutro, monocomponente, desarrollado para el sellado resistente a la intemperie altamente efectivo de juntas en muros cortina y fachadas de edificios con movimientos de ±50%.",
        caracteristicasRendimiento: "Excelente adhesión a una amplia gama de sustratos, incluidos vidrio revestido, acero galvanizado, aluminio anodizado y revestido de poliéster y acero inoxidable, y otros sustratos porosos y no porosos.  Adecuado para juntas de expansión, juntas de conexión, juntas perimetrales y otras juntas de temperatura.  Adecuado para juntas con movimientos de ±50% del ancho de junta original.  Resistencia a temperaturas de -60 °C a +180 °C.  Alta resistencia a la tensión mecánica.  Alta elasticidad y alta modularidad.  El sellador es resistente al ozono y a las manchas de materiales no porosos: aluminio, vidrio y acero inoxidable.",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 10,
        nombre: "MF 897 Sellador anti-moho de silicona",
        categoria: "Construcción",
        descripcionProducto: "SILANDE® MF 897 es un sellador de silicona RTV, monocomponente, de curado neutro y antifúngico, especialmente diseñado para el sellado impermeable de juntas en áreas de almacenamiento frigorífico de alimentos, áreas de cocina, duchas, baños, piscinas y otras áreas con alta humedad. El sellador es fácil de aplicar en cualquier clima. La polimerización se produce cuando la humedad del aire actúa sobre el sellador, que después de la polimerización forma una unión de silicona duradera y elástica.",
        caracteristicasRendimiento: "Excelentes propiedades antibacterianas y antifúngicas. Buena adhesión a una amplia gama de sustratos, incluidos vidrio revestido, vidrio flotado, madera, aluminio, cerámica y mampostería. Adecuado para uso en juntas de compresión/expansión ±25%. Excelente resistencia a las influencias atmosféricas, incluida la radiación UV, el calor y la humedad. Resistencia a temperaturas de -60 °C a +180 °C. Alta resistencia a la tensión mecánica. Alta elasticidad y alta modularidad. Sellador resistente al ozono",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 11,
        nombre: "MF890 Sellador de silicona para construcción",
        categoria: "Construcción",
        descripcionProducto: "SILANDE MF890 es un sellador de silicona curada neutra, de un componente, diseñado específicamente para sellar puertas y ventanas de viviendas, contenedores de carga, revestimientos metálicos de vidrio para automóviles, conductos y sellado interior en edificios y viviendas. También está diseñado para usarse en sellado de acristalamiento general y acristalamiento de salas de exposición, así como aplicaciones de impermeabilización y para no manchar paneles compuestos de aluminio. Se extruye fácilmente en cualquier clima y cura a temperatura ambiente mediante la reacción con la humedad del aire, formando un sello de caucho de silicona flexible y duradero.",
        caracteristicasRendimiento: "Excelente adhesión a una amplia gama de sustratos, incluidos vidrio revestido, acero galvanizado, mampostería, aluminio y acero inoxidable anodizados y revestidos con pintura de poliéster, y otros sustratos porosos y no porosos. Ideal para juntas de expansión, conexión, perimetrales y otros tipos de movimiento. Adecuado para uso en capacidad de movimiento de extensión/compresión de hasta +/- 20% del ancho de la junta original. Excelente estabilidad de temperatura: -5O°C a 180°C. Alto nivel de propiedades mecánicas. Excelente resistencia al envejecimiento climático.",
        normasAplicables: "GB/T 14683 G, F 20HM",
        colores: "Negro/blanco/gris/transparente. Se pueden solicitar colores personalizados para que coincidan con prácticamente cualquier sustrato.",
        packaging: "Cartucho: 300ml (25 unidades). Tubo: 592ml (20 unidades)",
        vidaUtil: "12 meses desde la fecha de fabricación, almacenar en un lugar fresco, seco y ventilado por debajo de 30℃ en el embalaje original sin abrir"
    },
    {
        id: 12,
        nombre: "MF 889F-25 Sellador de silicona climático",
        categoria: "Construcción",
        descripcionProducto: "Sellador de silicona monocomponente, neutro, de curado con vapor de agua a temperatura ambiente.",
        caracteristicasRendimiento: "Excelente rendimiento y tiempo de bloqueo contra incendios. Alta elasticidad, módulo bajo, utilizado junto con selladores estructurales de silicona resistentes al fuego que cumplen con los estándares ETAG002 y pueden proporcionar una garantía de calidad de 25 años. Excelente resistencia a altas y bajas temperaturas y al envejecimiento climático. Curado neutro, sin corrosión en la superficie adherida. Se puede lograr una buena adhesión para la mayoría de los materiales y componentes de construcción sin el uso de imprimación. Fácil de usar, puede ser extruido y aplicado en cualquier momento con pistola de pegamento general.",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 13,
        nombre: "MF 889A Sellador de silicona climático",
        categoria: "Construcción",
        descripcionProducto: "SILANDE® MF889A es un sellador de silicona RTV de curado neutro, monocomponente para piedra natural, diseñado para un sellado altamente efectivo y resistente a la intemperie de juntas en piedra, vidrio y otros materiales de construcción básicos sin imprimación. El sellador se puede aplicar en cualquier clima, la polimerización ocurre bajo la influencia de la humedad del aire, dando como resultado la formación de una costura elástica duradera hecha de caucho de silicona.",
        caracteristicasRendimiento: "Excelente adhesión a una amplia gama de sustratos sin el uso de imprimación, incluidos piedra natural, vidrio, metal, azulejos y aluminio anodizado. Adecuado para juntas de expansión y juntas de conexión. Adecuado para juntas con movimientos de ±25% del ancho de junta original. Resistencia a temperaturas de -60 °C a +180 °C. Alta elasticidad y alta modularidad. Sellador resistente al ozono",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 14,
        nombre: "MF 889-25 Sellador climático de silicona",
        categoria: "Construcción",
        descripcionProducto: "SILANDE® MF 897 es un sellador de silicona RTV, monocomponente, de curado neutro y antifúngico, especialmente diseñado para el sellado impermeable de juntas en áreas de almacenamiento frigorífico de alimentos, áreas de cocina, duchas, baños, piscinas y otras áreas con alta humedad. El sellador es fácil de aplicar en cualquier clima. La polimerización se produce cuando la humedad del aire actúa sobre el sellador, que después de la polimerización forma una unión de silicona duradera y elástica.",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 15,
        nombre: "MF889 Sellador de silicona climático",
        categoria: "Construcción",
        descripcionProducto: "SILANDEMF889 es un sellador de silicona para impermeabilización de un solo componente, de curado neutro y a temperatura ambiente, diseñado específicamente para acristalamiento general y sellado contra la intemperie en muros cortina y fachadas de edificios, sin manchar los paneles compuestos de aluminio. Se extruye fácilmente en cualquier condición climática y cura a temperatura ambiente mediante una reacción con la humedad del aire, formando un sello de caucho de silicona duradero y flexible.",
        caracteristicasRendimiento: "Excelente adhesión a una amplia gama de sustratos, incluidos vidrio recubierto, acero galvanizado, mampostería, aluminio anodizado y recubierto con pintura de poliéster y acero inoxidable y otros sustratos porosos y no porosos. Su alta resistencia a la tensión máxima lo hace ideal para aplicaciones de unión estructural. Excelentes características de intemperie y alta resistencia a la radiación ultravioleta, al calor y a la humedad. Excelente estabilidad de temperatura: -50°C a 180°C.Alto nivel de propiedades mecánicas. Buena resistencia al envejecimiento climático",
        normasAplicables: "ASTM C920, Type S, Grande NS, Class 35, NT, G, A. JC/T 882 25HM. GB/T 14683 G, F 25 HM. GB/T 22083 G, G 35HM. ISO 11600 F, G 25 HM.",
        colores: "Negro/blanco/gris. Se pueden solicitar colores personalizados para que coincidan con prácticamente cualquier sustrato. ",
        packaging: "Cartucho: 300ml (25 unidades). Tubo: 592ml (20 unidades)",
        vidaUtil: "12 meses desde la fecha de fabricación, almacenar en un lugar fresco, seco y ventilado por debajo de 30℃ en el embalaje original sin abrir"
    },
    {
        id: 16,
        nombre: "MF 883 Sellador de silicona para DVH",
        categoria: "Construcción",
        descripcionProducto: "SILANDE® MF 883 es un sellador de silicona monocomponente, de curado neutro, diseñado para sellar el contorno secundario de unidades de vidrio aislante con butilo como sello primario. También se recomienda para acristalamiento de vidrios microaislantes de borde abierto incrustados en tipos especiales de vidrio como vidrios ultrafinos (vidrio de células solares o vidrio de pantalla).",
        caracteristicasRendimiento: "Se forma una unión duradera y elástica entre el vidrio y la superficie del separador. Excelente adhesión a una amplia gama de sustratos sin imprimación. Curado neutro, no provoca corrosión de sustratos. Resistencia a temperaturas de -60 °C a +180 °C. No se descuelga, no contiene disolventes, no contamina el medio ambiente.",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 17,
        nombre: "MF 840 Sellador de polisulfuro para DVH",
        categoria: "Construcción",
        descripcionProducto: "SILANDE® MF840 es un sellador de polisulfuro de dos componentes para el sellado secundario de ventanas de doble acristalamiento. Adecuado para aplicación manual y automatizada. Desarrollado para la producción de ventanas y puertas de doble acristalamiento, así como para el procesamiento de bordes de marcos en sistemas de muro cortina.",
        caracteristicasRendimiento: "Excelente adhesión a una amplia gama de sustratos, incluido el vidrio; aluminio anodizado, galvanizado y acero inoxidable. Resistencia a temperaturas de -40 °C a +80 °C. Alta resistencia. Alta elasticidad. No contiene disolventes. No requiere imprimación previa de las bases.",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 18,
        nombre: "MF 882 Sellador de silicona neutra",
        categoria: "Construcción",
        descripcionProducto: "SILANDE MF882 es un sellador de silicona de curado neutro de dos componentes desarrollado para la producción de ventanas de doble vidrio utilizadas en ventanas y puertas, vehículos y refrigeradores. El sellador también se puede utilizar para tratar los bordes de los marcos en sistemas de muro cortina.",
        caracteristicasRendimiento: "Excelente adhesión a una amplia gama de sustratos, incluido vidrio revestido, esmaltado y reflectante; Aluminio anodizado y recubierto de poliéster y acero inoxidable. Resistencia a temperaturas de -50 °C a +150 °C. Alta resistencia al estrés mecánico. Alta modularidad y alta elasticidad. Resistente al ozono.",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 19,
        nombre: "MF 881-25G Sellador estructural de silicona",
        categoria: "Construcción",
        descripcionProducto: "SILANDE MF881-25G es un sellador de dos componentes, RTV, de curado neutro, de grado arquitectónico, diseñado específicamente para acristalamiento estructural de muros cortina de edificios de gran altura y muy altos, placas de vidrio de gran tamaño y muros cortina de edificios estructurales complejos, fabricación de unidades de vidrio aislante de alto rendimiento, sellado anticorrosión de bridas de tuberías, puentes, barcos, plantas de tratamiento de aguas residuales, metros, alcantarillas y plataformas petroleras.",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 20,
        nombre: "",
        categoria: "Construcción",
        descripcionProducto: "",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 21,
        nombre: "MF 881-25 Sellador de silicona neutra",
        categoria: "Construcción",
        descripcionProducto: "SILANDE MF 881-25 es un sellador de silicona de dos componentes, de curado neutro, polimerizado por la humedad del aire. Diseñado para acristalamiento estructural en construcciones de gran altura; para muros cortina en construcciones de gran altura; para sistemas de muro cortina de vidrio de gran tamaño; para estructuras de edificación complejas en muros cortina; para la producción de ventanas de doble acristalamiento de alta calidad.",
        caracteristicasRendimiento: "Excelente adhesión a una amplia gama de sustratos: vidrio revestido, esmaltado, reflectante; aluminio anodizado y revestido de poliéster y acero inoxidable y otras superficies porosas y no porosas. Resistencia a temperaturas de -60 °C a +180 °C. Alta resistencia a la tensión mecánica. Alta modularidad y alta elasticidad. Resistencia al ozono",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 22,
        nombre: "MF 881 Sellador de silicona neutra",
        categoria: "Construcción",
        descripcionProducto: "SILANDE® MF881 es un sellador de silicona de curado neutro, de dos componentes, diseñado para la producción de unidades de vidrio aislante de alta calidad en la construcción civil y comercial en sistemas de muro cortina y en acristalamiento estructural como el acristalamiento de fábrica de unidades y módulos de vidrio aislante.",
        caracteristicasRendimiento: "Excelente adhesión a una amplia gama de sustratos, incluido vidrio revestido, esmaltado y reflectante; aluminio anodizado y recubierto de poliéster y acero inoxidable. Resistencia a temperaturas de -60 °C a +180 °C, Alta resistencia a la tensión mecánica. Alta modularidad y alta elasticidad. Movimiento de costura ±25%. Resistente al ozono",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 23,
        nombre: "MF 281 Grasa termoconductora de silicona",
        categoria: "Electrónico",
        descripcionProducto: "SILANDE® MF 281 es un sellador de silicona de un solo componente, no curable, con alta conductividad térmica y basado en organosiloxano.",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 24,
        nombre: "MF 282 Sellador termoconductor de silicona",
        categoria: "Electrónico",
        descripcionProducto: "SILANDE® MF 282 es un sellador de silicona de un solo componente, curado a temperatura ambiente, con alta conductividad térmica y no fluido. Tiene buenas propiedades de adhesión y una excelente resistencia al clima.",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 25,
        nombre: "MF 280 Sellador electrónico de silicona",
        categoria: "Electrónico",
        descripcionProducto: "SILANDE® MF 282 es un sellador de silicona de un solo componente, curado a temperatura ambiente, con alta conductividad térmica y no fluido. Tiene buenas propiedades de adhesión y una excelente resistencia al clima.",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 26,
        nombre: "MF 210 Adhesivo termoconductor",
        categoria: "Electrónico",
        descripcionProducto: "SILANDE® MF 210 es un sistema de encapsulación térmicamente conductivo de silicona de dos componentes. El Componente A y el Componente B están en una proporción de masa de 10:1.MF 210 puede curarse a temperatura ambiente.",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 27,
        nombre: "MF 211 Sellador térmico",
        categoria: "Electrónico",
        descripcionProducto: "Los encapsulantes de silicona térmicamente conductivos SILANDE® MF 211 pueden curarse a temperatura ambiente, pero también pueden acelerar el curado a altas temperaturas. Una vez curados, no presentan una contracción significativa en diversos materiales.",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 28,
        nombre: "MF 4150 Silicona plástica",
        categoria: "Electrónico",
        descripcionProducto: "Silicona líquida transparente óptica de dos componentes, curable por adición.",
        caracteristicasRendimiento: "Índice de refracción de 1,41. Alta transparencia, con una tasa de transmisión de luz superior al 93%. Alta dureza, alta resistencia.",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 29,
        nombre: "MF 4160 Silicona plástica",
        categoria: "Electrónico",
        descripcionProducto: "Silicona líquida transparente óptica de dos componentes, curable por adición.",
        caracteristicasRendimiento: "Índice de refracción de 1,41. Alta transparencia, con una tasa de transmisión de luz superior al 93%. Alta dureza, alta resistencia.",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 30,
        nombre: "MF 5360 Silicona adhesiva para LED",
        categoria: "Electrónico",
        descripcionProducto: "",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 31,
        nombre: "MF 5380 Silicona encapsulante para LED",
        categoria: "Electrónico",
        descripcionProducto: "",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 32,
        nombre: "MF 1308 Adhesivo epoxy de curado rápido",
        categoria: "Electrónico",
        descripcionProducto: "",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 33,
        nombre: "MF 1309 Adhesivo epoxy de curado rápido",
        categoria: "Electrónico",
        descripcionProducto: "",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 34,
        nombre: "MF 1560 SMT parchador plástico",
        categoria: "Electrónico",
        descripcionProducto: "",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 35,
        nombre: "MF 203 Sellador de parabrisas de poliuretano",
        categoria: "Automotriz",
        descripcionProducto: "SILANDE® MF 203 es principalmente aplicado en el ensamblaje directo de parabrisas de automóviles, el sellado de vidrios de ventanas laterales y traseras, y el sellado de juntas en embarcaciones, contenedores y contenedores refrigerados, etc.",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 36,
        nombre: "MF 212 Sellador climático de silicona",
        categoria: "Automotriz",
        descripcionProducto: "SILANDE® MF 212 es un sellador de silicona monocomponente, de curado neutro, alta flexibilidad y alto módulo. Posee excelente resistencia al aceite, aislamiento eléctrico, resistencia al agua y resistencia a altas y bajas temperaturas.",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 37,
        nombre: "MF 892 Sellador automotriz de silicona",
        categoria: "Automotriz",
        descripcionProducto: "",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 38,
        nombre: "MF 962 Sellador electrónico de silicona",
        categoria: "PanelesSolares",
        descripcionProducto: "SILANDE® MF 962 es un sellador de silicona de dos componentes de alta elasticidad, de curado a temperatura ambiente en ambiente neutro. Tiene una excelente resistencia al fuego, excelente resistencia a la radiación ultravioleta y al envejecimiento por aire. Se utiliza principalmente para sellar y sellar herméticamente módulos de paneles solares, pantallas fotovoltaicas y otros productos electrónicos, etc.",
        caracteristicasRendimiento: "Alta elasticidad. Excelente resistencia al fuego. No contamina el medio ambiente. Curado neutro, no provoca corrosión superficial. Excelente resistencia a la radiación UV y al envejecimiento por aire. Excelente adherencia al vidrio, cerámica, metal. Excelente resistencia a bajas y altas temperaturas, y buena capacidad en el rango de -60ºC a 7ºC.",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 39,
        nombre: "MF 962-L Sellador solar de silicona",
        categoria: "PanelesSolares",
        descripcionProducto: "SILANDE® MF 962 - silicona RTV de dos componentes, material de encapsulación aislante de tipo condensación. No genera disipación de calor ni corrosión durante el curado y tiene un bajo porcentaje de contracción. Se aplica principalmente en la encapsulación de cajas de conexiones de módulos solares.",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 40,
        nombre: "MF 961 Sellador de silicona",
        categoria: "PanelesSolares",
        descripcionProducto: "SILANDE® MF 961 - Sellador RTV de curado neutro de un componente, desarrollado específicamente para sellar módulos solares.",
        caracteristicasRendimiento: "Excelente adhesión a una amplia gama de superficies, incluido vidrio, cerámica, metal, cajas de conexiones y láminas de soporte, sin corrosión. Buenas propiedades de resistencia a la intemperie y alta resistencia a la radiación ultravioleta, al calor y a la humedad. Curado rápido y alta elasticidad. Excelente estabilidad de temperatura: desde -60°C hasta 180°C. Sin contaminación ambiental.",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 41,
        nombre: "MF 886F Sellador ácido de temperatura",
        categoria: "Impermeabilizantes",
        descripcionProducto: "",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 42,
        nombre: "MF 521 Sellador de polisulfuro para protección de pernos",
        categoria: "Impermeabilizantes",
        descripcionProducto: "El sellador de polisulfuro SILANDE® MF 521 para protección de pernos es un sellador elastomérico de dos componentes, bajo módulo, alta elongación y curado a temperatura ambiente. Posee un excelente desempeño en impermeabilización y resistencia al aceite y productos químicos.",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 43,
        nombre: "MF 860F Sellador de polisulfuro anticorrosivo",
        categoria: "Impermeabilizantes",
        descripcionProducto: "SILANDE® MF 860F es un sellador de polisulfuro de dos componentes basado en caucho de polisulfuro líquido como material base. A temperatura ambiente se solidifica en un elastómero que tiene excelente resistencia al aceite, resistencia al agua y anti-envejecimiento.",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 44,
        nombre: "MF 860L Sellador termoconductor de silicona",
        categoria: "Impermeabilizantes",
        descripcionProducto: "SILANDE® MF 860 es un sellador de polisulfuro de dos componentes que, después de la polimerización, tiene excelente resistencia al aceite, resistencia al agua, resistencia al envejecimiento, resistencia a la corrosión y buena elasticidad. Fuertes propiedades adhesivas para vidrio, aluminio, hormigón, acero galvanizado y otros materiales. Se utiliza para impermeabilización y sellado anticorrosivo de puentes, barcos, instalaciones de tratamiento, derivaciones y alcantarillas. Ubicado en el edificio y en el sótano.",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 45,
        nombre: "MF 2000B Sellador anticorrosivo",
        categoria: "Impermeabilizantes",
        descripcionProducto: "SILANDE® MF 2000B es un sellador de caucho monocomponente no vulcanizado, de curado neutro, no secante. Tiene buena flexibilidad y escalabilidad, y también buena capacidad de sellado, resistencia al agua y resistencia al envejecimiento",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 46,
        nombre: "MF 2000G Sellador anticorrosivo",
        categoria: "Impermeabilizantes",
        descripcionProducto: "SILANDE® MF 2000G es un sellador de caucho monocomponente no vulcanizado, de curado neutro, no secante. Tiene buena flexibilidad y escalabilidad, y también buena capacidad de sellado, resistencia al agua y resistencia al envejecimiento.",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 47,
        nombre: "MF 2000H Sellador impermeable",
        categoria: "Impermeabilizantes",
        descripcionProducto: "SILANDE® MF 2000H es un sellador plástico monocomponente, sin solventes, no curante y permanente. Con un amplio rango de temperatura para mantener su plasticidad y hermeticidad a largo plazo, sin grietas en la superficie ni endurecimiento.",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },
    {
        id: 48,
        nombre: "",
        categoria: "Electrónico",
        descripcionProducto: "",
        caracteristicasRendimiento: "",
        normasAplicables: "",
        colores: "",
        packaging: ""
    },

];

export default MockProducts;
